import React, { useEffect } from 'react';
import useGlobal from '../../../../store';
import { Col, Row } from 'react-bootstrap';
import Table from '../../../../facturotopia/table/Table';

const mapState = (store) => store.admin.reportes.pacs.balance;
const mapActions = (actions) => actions.admin.reportes.pacs.balance;

const columnsGeneral = [
  {
    key: 'pac',
    title: 'Pac',
    dataIndex: 'pac',
    className: 'width-100',
  },
  {
    key: 'ejercicio',
    title: 'Ejercicio',
    dataIndex: 'ejercicio',
    className: 'width-100',
  },
  {
    key: 'comprobantes',
    title: 'Comprobantes',
    dataIndex: 'comprobantes',
    className: 'text-right width-100',
  },
  {
    key: 'retenciones',
    title: 'Retenciones',
    dataIndex: 'retenciones',
    className: 'text-right width-100',
  },
  {
    key: 'cancelaciones',
    title: 'Cancelaciones',
    dataIndex: 'cancelaciones',
    className: 'text-right width-100',
  },
  {
    key: 'total',
    title: 'Total',
    dataIndex: 'total',
    className: 'text-right width-100 legend',
  },
  {
    key: 'asignados',
    title: 'Asignados',
    dataIndex: 'asignados',
    className: 'text-right width-100 legend',
  },
  {
    key: 'hits',
    dataIndex: 'hits',
    title: 'Balance',
    className: 'text-right width-100 legend font-bold',
  },
];

const columns = [
  {
    key: 'pac',
    title: 'Pac',
    dataIndex: 'pac',
    className: 'width-100',
  },
  {
    key: 'ejercicio',
    title: 'Ejercicio',
    dataIndex: 'ejercicio',
    className: 'width-100',
  },
  {
    key: 'mes',
    title: 'Mes',
    dataIndex: 'mes',
    className: 'width-100',
  },
  {
    key: 'comprobantes',
    title: 'Comprobantes',
    dataIndex: 'comprobantes',
    className: 'text-right width-100',
  },
  {
    key: 'retenciones',
    title: 'Retenciones',
    dataIndex: 'retenciones',
    className: 'text-right width-100',
  },
  {
    key: 'cancelaciones',
    title: 'Cancelaciones',
    dataIndex: 'cancelaciones',
    className: 'text-right width-100',
  },
  {
    key: 'total',
    title: 'Total',
    dataIndex: 'total',
    className: 'text-right width-100 legend',
  },
  {
    key: 'asignados',
    title: 'Asignados',
    dataIndex: 'asignados',
    className: 'text-right width-100 legend',
  },
  {
    key: 'hits',
    dataIndex: 'hits',
    title: 'Balance',
    className: 'text-right width-100 legend font-bold',
  },
];

const AdminReportesPacsBalanceItem = ({ pac, busy, data }) => {
  return (
    <>
      <Row>
        <Col>
          <p className="text-upper font-bold ">{pac}</p>
        </Col>
      </Row>

      <Row>
        <Col>
          <Table
            className="legend"
            columns={columns}
            rowKey={'id'}
            data={data}
            busy={busy}
          />
        </Col>
      </Row>
    </>
  );
};

const AdminReportesPacsBalanceGeneral = ({ data, busy }) => {
  const groupedData = Object.entries(data || {}).reduce((acc, curr) => {
    const [pac, balance] = curr;

    const total = (balance || []).reduce((sum, row) => sum + parseInt(row?.total), 0);

    const asignados = (balance || []).reduce((sum, row) => sum + parseInt(row?.asignados), 0);

    const cancelaciones = (balance || []).reduce((sum, row) => sum + parseInt(row?.cancelaciones), 0);

    const comprobantes = (balance || []).reduce((sum, row) => sum + parseInt(row?.comprobantes), 0);

    const retenciones = (balance || []).reduce((sum, row) => sum + parseInt(row?.retenciones), 0);

    const hits = (balance || []).reduce((sum, row) => parseInt(row?.hits), 0);

    const ejercicio = (balance || []).reduce((_, row) => row?.ejercicio, '');

    const pac_id = (balance || []).reduce((_, row) => row?.pac_id, '');

    return {
      ...acc,
      [pac]: {
        total,
        hits,
        pac_id,
        asignados,
        ejercicio,
        retenciones,
        comprobantes,
        cancelaciones,
      },
    };
  }, {});

  const generalData = Object.entries(groupedData || {}).map(([pac, group]) => ({
    pac,
    ...group,
    id: `${group['ejercicio']}_${group['pac_id']}`,
  }));

  return (
    <Row>
      <Col>
        <Table
          className="legend"
          columns={columnsGeneral}
          rowKey={'id'}
          data={generalData}
          busy={busy}
        />
      </Col>
    </Row>
  );
};

const AdminReportesPacsBalanceListManager = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { data, busy } = state;

  useEffect(() => {
    actions.list();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const pacReports = Object.entries(data || {}).map(([pac, balance]) => (
    <AdminReportesPacsBalanceItem
      pac={pac}
      busy={busy}
      data={balance}
      key={`${pac}_balance`}
    />
  ));

  return (
    <>
      <Row>
        <Col>
          <strong>Balance General</strong>
        </Col>
      </Row>
      <AdminReportesPacsBalanceGeneral
        data={data}
        busy={busy}
      />
      <Row>
        <Col>
          <strong>Balance por Pac</strong>
        </Col>
      </Row>
      {pacReports}
    </>
  );
};

export default AdminReportesPacsBalanceListManager;
